import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Search, Settings } from 'lucide-react';
import { trNorm } from '@/lib/arama';

export default function ExpenseItemsList() {
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState('');

  useEffect(() => {
    api.get('/expense-items').then(r => setItems(r.data)).catch(() => {});
  }, []);

  const filtered = items.filter(i =>
    !search || trNorm(i.name).includes(trNorm(search)) || trNorm(i.code).includes(trNorm(search))
  );

  return (
    <div data-testid="expense-items-page">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-3xl font-bold text-[#1a1916] tracking-tight">Gider Kalemleri</h1>
          <p className="text-sm text-[#8a7e70] mt-1">{filtered.length} kalem</p>
        </div>
        <Link to="/erp/admin">
          <Button variant="outline" className="border-[#d0c4b0] text-[#3F3E39] hover:bg-[#e8dfd0]" data-testid="goto-admin-btn">
            <Settings size={16} className="mr-2" /> Admin Panelinden Yonet
          </Button>
        </Link>
      </div>

      <div className="relative max-w-sm mb-6">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#8a7e70]" />
        <Input placeholder="Kalem ara..." value={search} onChange={(e) => setSearch(e.target.value)}
          className="pl-9 bg-white border-[#d0c4b0]" data-testid="expense-search" />
      </div>

      <div className="bg-[#faf7f2] border border-[#d0c4b0] rounded-lg overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="bg-[#e8dfd0] hover:bg-[#e8dfd0]">
              <TableHead className="text-[#1a1916] font-bold text-xs uppercase">Kod</TableHead>
              <TableHead className="text-[#1a1916] font-bold text-xs uppercase">Kalem Adi</TableHead>
              <TableHead className="text-[#1a1916] font-bold text-xs uppercase">Kategori</TableHead>
              <TableHead className="text-[#1a1916] font-bold text-xs uppercase text-right">KDV %</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filtered.map(item => (
              <TableRow key={item.id} className="erp-table-row border-[#d0c4b0]">
                <TableCell className="font-mono text-sm text-[#8a7e70]">{item.code}</TableCell>
                <TableCell className="font-medium text-[#1a1916]">{item.name}</TableCell>
                <TableCell className="text-sm text-[#3F3E39]">{item.category_name || '-'}</TableCell>
                <TableCell className="text-right text-sm text-[#3F3E39]">%{item.kdv_rate}</TableCell>
              </TableRow>
            ))}
            {filtered.length === 0 && (
              <TableRow><TableCell colSpan={4} className="text-center py-8 text-[#8a7e70]">Kalem bulunamadi</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
